import { Component, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidCatch(error: Error) {
    console.error(error);
  }
  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-dvh grid place-items-center p-6 text-center bg-ink">
        <div className="card p-6 max-w-sm flex flex-col items-center gap-4">
          <img src="/mascot-laugh.webp" alt="Pop laughing so hard it fell over" width={150} height={147} />
          <p className="font-display font-black text-2xl">Something broke on this screen</p>
          <p className="text-mute text-sm">Your spot in the party is safe. Reloading puts you right back in.</p>
          <button className="btn" onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
